/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSailboat = createReactComponent("outline", "sailboat", "IconSailboat", [["path", { "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1", "key": "svg-0" }], ["path", { "d": "M4 18l-1 -3h18l-1 3", "key": "svg-1" }], ["path", { "d": "M11 12h7l-7 -9v9", "key": "svg-2" }], ["path", { "d": "M8 7l-2 5", "key": "svg-3" }]]);

export { IconSailboat as default };
//# sourceMappingURL=IconSailboat.mjs.map
